import moment from 'moment';

export const formatTime = ({ date, time }, isTimestamp) => {
  const { hour, minute, division } = time;

  const m = moment(date);

  m.hour(parseInt(hour));
  m.minute(parseInt(minute));
  m.second(0);

  if (division === 'pm') {
    m.add(12, 'hours');
  }

  if (isTimestamp) {
    return m.utc().valueOf();
  }

  const formattedDate = m.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z';

  return formattedDate;
};

export const getStartAndEndTimestamps = (timestamp, unit) => {
  const date = moment(timestamp).utc();

  return {
    start: date.clone().startOf(unit?.slice(0, -1)).valueOf(),
    end: date.clone().endOf(unit?.slice(0, -1)).valueOf(),
  };
};

export const readableTime = (time) => {
  const date = moment(time).utc();
  const hour = date.format('hh');
  const minute = date.format('mm');
  const division = date.format('a');

  const timeObject = {
    date: moment(time).utc().startOf('day')._d,
    time: {
      hour,
      minute,
      division,
    },
  };

  return timeObject;
};

export const countdownTimer = (time) => {
  const duration = moment.duration(time, 'seconds');
  const countdown = {
    hours:
      duration._data.hours + duration._data.days * 24 < 10
        ? '0' + duration.hours()
        : duration._data.hours + duration._data.days * 24,
    minutes:
      duration.minutes() < 10 ? '0' + duration.minutes() : duration.minutes(),
    seconds:
      duration.seconds() < 10 ? '0' + duration.seconds() : duration.seconds(),
  };
  return `${countdown.hours}:${countdown.minutes}:${countdown.seconds}`;
};

export const formatDateXAxis = (intervalUnit) => {
  let result;
  switch (intervalUnit) {
    case 'months':
      result = 'MMM';
      break;
    case 'weeks':
      result = 'ww';
    case 'days':
      result = 'DD';
      break;
    case 'hours':
      result = 'HH';
      break;
    case 'minutes':
      result = 'mm';
      break;
  }
  return result;
};

export const formatDateTooltip = (intervalUnit) => {
  let result;
  switch (intervalUnit) {
    case 'months':
    case 'weeks':
      result = 'MMMM YYYY';
      break;
    case 'days':
      result = 'MMMM dddd DD, YYYY';
      break;
    case 'hours':
    case 'minutes':
      result = 'MMMM dddd DD, YYYY - hh:mm a';
      break;
  }
  return result;
};
